<template>
    <section class="p-4 md:p-8 rounded-2xl overflow-hidden mb-20 bg-[rgba(12,21,36,0.4)]">
        <div>
            <div class="flex flex-col lg:flex-row gap-6 md:gap-8 lg:gap-12 items-start lg:items-center">
                <!-- Left Content -->
                <div class="relative w-full lg:max-w-3xl lg:flex-1">
                    <div class="absolute -top-[200px] md:-top-[400px] -left-[300px] md:-left-[600px] w-[376px] md:w-[752px] h-[376px] md:h-[752px] rounded-full blur-[100px] md:blur-[200px] 
         bg-[linear-gradient(121.22deg,rgba(71,209,140,0.32)_0%,rgba(102,163,255,0.32)_100%)]">
                    </div>

                    <h1
                        class="text-xl md:text-2xl lg:text-3xl font-bold mb-6 md:mb-8 text-[var(--text-primary)] relative z-10">
                        Pre-Built E-Commerce Pages
                    </h1>

                    <p class="text-lg md:text-xl text-[var(--text-gray)] mb-6 md:mb-7 leading-relaxed relative z-10">
                        Accelerate your store launch with pre-designed pages, including:
                    </p>

                    <div class="space-y-3 md:space-y-4 relative z-10">
                        <div v-for="(feature, index) in features" :key="index" class="">
                            <span
                                class="text-[#47D18C] text-lg md:text-xl font-bold mr-0 sm:mr-2 mb-1 sm:mb-0 flex-shrink-0">
                                {{ feature.title }}
                            </span>
                            <span class="text-[var(--text-gray)] text-lg md:text-xl leading-6 md:leading-7">
                                {{ feature.description }}
                            </span>
                        </div>
                    </div>
                </div>

                <!-- Right Content - Grid of Cards -->
                <div class="w-full lg:w-auto lg:flex-shrink-0">
                    <div class="grid grid-cols-2 gap-3 md:gap-4 lg:gap-6 max-w-md mx-auto lg:mx-0">
                        <div v-for="(card, index) in cards" :key="index"
                            :class="['aspect-square rounded-xl lg:rounded-2xl flex items-center justify-center', card.bg]">
                            
                               
                                <NuxtImg :src="card.image" alt="E-commerce page preview" width="212" height="224"
                                    class="object-cover w-full h-full rounded-xl" loading="lazy" />
                            

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
const features = [
    { title: "Homepage:", description: "Engaging layouts to showcase your brand." },
    { title: "Cart:", description: "Simplified for smooth customer checkout." },
    { title: "PLP (Product Listing Page):", description: "Feature-rich for easy navigation and filtering." },
    { title: "PDP (Product Detail Page):", description: "Highlight products with detailed descriptions and visuals." },
]

const cards = [
    {
        bg: "bg-[#162236]",
        image: "/images/services-section/home.png",
    },
    {
        bg: "bg-[#0c1524]",
        image: "/images/services-section/cart.png",
    },
    {
        bg: "bg-[#162236]",
        image: "/images/services-section/plp.png",
    },
    {
        bg: "bg-[#0c1524]",
        image: "/images/services-section/pdp.png",
    },
]
</script>